import { Button, Flex, Form, Grid, Label, Popup, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { messages as countryNames } from 'shared/constants/countryNames';
import { PaymentDetailsLegalEntityType } from 'shared/data/webApp/v2';

import { FormValues } from '../../EditCounterpartyPaymentDetailsPopupContent.types';
import { messages } from './IncorrectInfoPopupContent.messages';
import { IncorrectInfoPopupContentProps } from './IncorrectInfoPopupContent.types';

export const IncorrectInfoPopupContent = memo<IncorrectInfoPopupContentProps>((props) => {
    const { isLoading, reasonCode, onBack } = props;

    const form = useFormContext<FormValues>();

    const [
        payeeBankCountry,
        currencyCode,
        bankAccountNumber,
        sortCode,
        companyName,
        firstName,
        lastName,
        legalEntityType,
    ] = form.watch([
        'payeeBankCountry',
        'currencyCode',
        'bankAccount.routing.bankAccountNumber',
        'bankAccount.routing.sortCode',
        'legalEntity.companyName',
        'legalEntity.firstName',
        'legalEntity.lastName',
        'legalEntity.legalEntityType',
    ]);

    const fields = [
        {
            label: messages.name,
            value: legalEntityType === PaymentDetailsLegalEntityType.Company ? companyName : `${firstName} ${lastName}`,
        },
        {
            label: messages.country,
            value: countryNames[payeeBankCountry as keyof typeof countryNames] || payeeBankCountry,
        },
        {
            label: messages.currency,
            value: currencyCode,
        },
        {
            label: messages.entityType,
            value: legalEntityType === PaymentDetailsLegalEntityType.Company ? messages.company : messages.individual,
        },
        {
            label: messages.accountNumber,
            value: bankAccountNumber,
        },
        {
            label: messages.sortCode,
            value: sortCode,
        },
    ];

    return (
        <Form.Part>
            <Popup.Header title={messages.title} />

            <Popup.Body>
                <Grid rowGap={24}>
                    <Text font='body' fontSize='medium'>
                        {reasonCode === 'AV305' ? messages.accountSwitched : messages.differentBusinessType}
                    </Text>

                    <Grid rowGap={8}>
                        {fields.map(({ label, value }) => (
                            <Flex key={label} spacing='8'>
                                <Label size='medium'>{label}</Label>

                                <Text font='label' fontSize='medium'>
                                    {value}
                                </Text>
                            </Flex>
                        ))}
                    </Grid>

                    <Grid gridTemplateColumns='max-content max-content' gap={16} justifyContent='flex-end'>
                        <Button disabled={isLoading} color='midnight40' size='large' onClick={onBack}>
                            {messages.back}
                        </Button>

                        <Button color='blue80' size='large' progress={isLoading} type='submit'>
                            {messages.confirm}
                        </Button>
                    </Grid>
                </Grid>
            </Popup.Body>
        </Form.Part>
    );
});

IncorrectInfoPopupContent.displayName = 'IncorrectInfoPopupContent';
